import React, { useEffect, useState } from "react";
import "../styles/CourseCardChildStyles.css";
import streakImg from "../../dashboard/assets/star 4.svg";
import fire from "../../dashboard/assets/fire.svg";
import infoIcon from "../assets/images/courseinfo.png";
import NewIcon from "../../recommendation/assets/images/New.svg";
import { Recommendation } from "../data/response/VideoLandingPageResponse";
import GenericModal from "./GenericModelComponent";
import { handleImageErrorCallBack } from "../../recommendation/recommendation_industry_view/components/ErrorImage_PlaceHolder";
import { CourseNameTitleTextComponent } from "../../recommendation/recommendation_industry_view/components/TopicNameTittleText";
import { CardText } from "reactstrap";
import { logActionEvent } from "../../../analytics/analytics_utils";
import analytics_strings from "../../../analytics/analytics_strings";
import { RootState } from "../../../store/store";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../../service/ApiContext";
import { LocalStorage } from "../../../utils/Utils";
import Logger from "../../../utils/Logger";
import Loader from "../../../utils/Utils";
import { VideoReportClient } from "../../dashboard/data/client/VideoReportClient";
import { StreakUpResponse } from "../../dashboard/data/interface/StreakUpResponse";
import OverallProgressListPendingItems from "../../dashboard/components/OverallProgressListPendingItems";
import CardBottomOverlay from "../../dashboard/components/CardBottomOverlay";
import LearningContentPendingList from "./LearningContenPendingList";
import { LearningContentCountResponse } from "../data/response/LearingContentCount";
interface CourseCardChildPageProps {
  records: Recommendation[] | null;
  industry_program_id: string | undefined;
  program_description: string | undefined;
  program_title: string | undefined;
}
const CouresCardChildPage: React.FC<CourseCardChildPageProps> = ({
  records,
  industry_program_id,
  program_description,
  program_title,
}) => {
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const navigate = useNavigate();

  //Course Card Selections
  const [selectedCourse, setSelectedCourse] = useState<Recommendation | null>(
    null,
  );
  const handleIndustryDataClick = (data: any) => {
    navigate("/dashboard/learning-room/view-courses", {
      state: {
        course_id: data.course_id,
        course_name: data.course_title,
        program_id: industry_program_id,
        program_description: program_description,
        program_title: program_title,
      },
    });
  };
  const api = useApi();
  const [streakData, setStreakData] =
    useState<LearningContentCountResponse | null>(null);

  const getLearningCountApi = async () => {
    Loader.showLoading("Loading...");
    // setLoading(true);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<LearningContentCountResponse>(
        VideoReportClient.learning_content_count,
        { program_id: industry_program_id },
      );
      // const data: StreakUpUIResponse = {
      //   total:
      //     response.data.total_no_of_assessment +
      //     response.data.total_no_of_learning_content,
      //   completed:
      //     response.data.completed_no_of_assessment +
      //     response.data.completed_no_of_learning_content,
      //   completed_percentage_of_learning_content:
      //     response.data.completed_percentage_of_learning_content,
      // };

      setStreakData(response.data);
    } catch (error) {
      Logger.info("error response", error);
      // Display an error alert or message if needed
    } finally {
      Loader.dismissLoading();
    }
  };
  const [assessmentClicked, setAssessmentClicked] = useState<boolean>(false);

  useEffect(() => {
    getLearningCountApi();
  }, []);
  return (
    <div className="learning-container">
      {/* Top Cards */}
      <div className="top-cards">
        <div className="progress-card">
          <span className="title">Learning Progress</span>
          <span className="percentage">
            {streakData?.completed_percentage_of_learning_content}%
          </span>
        </div>

        <div className="completion-card">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "start",
              gap: "8px",
            }}
          >
            <div className="title">Learning Completion Rate</div>

            {streakData?.completed_percentage_of_learning_content !== 100 && (
              <img
                src={streakImg}
                alt=""
                style={{ height: "20px", width: "20px" }}
              />
            )}

            {streakData?.completed_percentage_of_learning_content !== 100 && (
              <div
                className="v2-dash-streakUp"
                onClick={() => {
                  setAssessmentClicked(true);
                  // setOpenOverlay(true);
                }}
              >
                Next Step
              </div>
            )}
          </div>

          <div className="completion-count">
            <img
              src={fire}
              alt=""
              style={{
                height: "22px",
                width: "22px",
              }}
            />{" "}
            <span>
              {streakData?.completed_video_count}/{" "}
              {streakData?.total_video_count}
            </span>
          </div>
        </div>
      </div>
      <LearningContentPendingList
        isOpen={assessmentClicked}
        onClose={() => {
          setAssessmentClicked(false);
        }}
        // cardHeight="40vh"
        cardWidth="40%"
        program_id={industry_program_id}
      />

      {/* Course Cards */}
      <div className="course-grid">
        {records &&
          records.map((item, index) => (
            <div
              key={index}
              className={`course-card ${
                item.completion_status === "Completed"
                  ? "completed-card"
                  : item.completion_status === "In Progress"
                    ? "progress-card-bg"
                    : ""
              }`}
              onClick={() => {
                if (!item.has_videos) return;
                //Log the Course Event
                logActionEvent(
                  analytics_strings.analytics_events.course_viewed,
                  {
                    candidate_id: userData.candidate_id,
                    course_name: item.course_title,
                  },
                );
                handleIndustryDataClick(item);
              }}
            >
              <div className="image-container">
                {item?.course_thumbnail !== null &&
                item?.course_thumbnail !== undefined ? (
                  <img
                    alt={item.course_title ?? ""}
                    src={item?.course_thumbnail || "https://pick.com"}
                    className="card-img"
                    onError={(e) =>
                      handleImageErrorCallBack(e, "100%", "160px")
                    }
                  />
                ) : (
                  <div className="no-thumbnail-placeholder">
                    Thumbnail Image Missing
                  </div>
                )}

                <div
                  className="lr-info-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedCourse(item);
                  }}
                >
                  <img src={infoIcon} className="courseinfoicon"></img>
                </div>
              </div>

              {/* <p className="course-card-title">Week 1: Make Disco Lights</p> */}
              <CourseNameTitleTextComponent title={item.course_title} />
              <p className="course-card-subtitle">{item.course_description}</p>

              <div className="course-info">
                <span>
                  • {item?.total_videos}{" "}
                  {(item?.total_videos ?? 0) > 1 ? "videos" : "video"}
                </span>
                <span>
                  • {item?.total_files ?? 0}{" "}
                  {(item?.total_files ?? 0) > 1 ? "Documents" : "Document"}
                </span>
                {item.is_new && (
                  <img
                    alt="Additional Icon"
                    src={NewIcon}
                    className="additionals-image-course"
                  />
                )}
                {/* <span className="new-tag">NEW</span> */}
              </div>

              <button
                className={`status-btn ${
                  item.completion_status === "Not Started" ? "not-started" : ""
                }`}
                onClick={() => {
                  if (!item.has_videos) return;
                  //Log the Course Event
                  logActionEvent(
                    analytics_strings.analytics_events.course_viewed,
                    {
                      candidate_id: userData.candidate_id,
                      course_name: item.course_title,
                    },
                  );
                  handleIndustryDataClick(item);
                }}
              >
                {item.completion_status === "Not Started"
                  ? "Yet to Start"
                  : item.completion_status}
              </button>
            </div>
          ))}
      </div>
      {/* <GenericModal
        isOpen={selectedCourse !== null}
        title="Course Information"
        onClose={() => {
          setSelectedCourse(null);
        }}
        width="60vh"
      >
        {selectedCourse?.course_thumbnail !== null &&
        selectedCourse?.course_thumbnail !== undefined ? (
          <img
            alt={selectedCourse.course_title ?? ""}
            src={selectedCourse?.course_thumbnail || "https://pick.com"}
            className="card-img-prog"
            onError={(e) => handleImageErrorCallBack(e, "100%", "160px")}
          />
        ) : (
          <div className="no-thumbnail-placeholder">
            Thumbnail Image Missing
          </div>
        )}
        <CourseNameTitleTextComponent
          title={selectedCourse?.course_title ?? ""}
        />
        <CardText>{selectedCourse?.course_description}</CardText>
        <p className="list-child" style={{ fontSize: "0.8rem" }}>
          {selectedCourse?.total_videos}{" "}
          {(selectedCourse?.total_videos ?? 0) > 1 ? "videos" : "video"}
          {" , "}
          {selectedCourse?.total_files ?? 0}{" "}
          {(selectedCourse?.total_files ?? 0) > 1 ? "Documents" : "Document"}
          <span>
            {" "}
            {selectedCourse?.is_new && (
              <img
                alt="Additional Icon"
                src={NewIcon}
                className="additionals-image-course"
              />
            )}
          </span>
        </p>
      </GenericModal> */}
      <GenericModal
        isOpen={selectedCourse !== null}
        title="Phase Information"
        onClose={() => {
          setSelectedCourse(null);
        }}
        width="90vh"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "start",
            justifyContent: "start",
            gap: "15px",
          }}
        >
          {selectedCourse?.course_thumbnail !== null &&
          selectedCourse?.course_thumbnail !== undefined ? (
            <img
              alt={selectedCourse.course_title ?? ""}
              src={selectedCourse?.course_thumbnail || "https://pick.com"}
              className="card-img-prog"
              onError={(e) => handleImageErrorCallBack(e, "50%", "160px")}
            />
          ) : (
            <div className="no-thumbnail-placeholder-model">
              Thumbnail Image Missing
            </div>
          )}
          <div
            style={{
              flex: 1,
              minWidth: 0,
            }}
          >
            <p
              style={{
                color: "#2D2D2D",
                fontFamily: "Mazzard",
                fontWeight: "700",
                fontSize: "20px",
              }}
            >
              {selectedCourse?.course_title ?? ""}
            </p>
            {/* <CourseNameTitleTextComponent
              title={selectedCourse?.course_title ?? ""}
            /> */}
            <CardText>{selectedCourse?.course_description}</CardText>
            <p className="list-child" style={{ fontSize: "0.8rem" }}>
              <span style={{ margin: "0 6px" }}>•</span>
              {selectedCourse?.total_videos}{" "}
              {(selectedCourse?.total_videos ?? 0) > 1 ? "videos" : "video"}
              {/* {" , "} */}
              <span style={{ margin: "0 6px" }}>•</span>
              {selectedCourse?.total_files ?? 0}{" "}
              {(selectedCourse?.total_files ?? 0) > 1
                ? "Documents"
                : "Document"}
              <span>
                {" "}
                {selectedCourse?.is_new && (
                  <img
                    alt="Additional Icon"
                    src={NewIcon}
                    className="additionals-image-course"
                  />
                )}
              </span>
            </p>
          </div>
        </div>
      </GenericModal>
    </div>
  );
};

export default CouresCardChildPage;
